import { errorLog } from "./logger";
export const defaultReporter = (e, extra) => errorLog("exceptionReporter", `${e.name} ${e.message} ${JSON.stringify(extra)}`);
let exceptionReporter = defaultReporter;
export function setExceptionReporter(reporter) {
    exceptionReporter = reporter;
}
export function captureException(error, service, extra) {
    exceptionReporter(error, {
        service,
        ...extra,
    });
}
//# sourceMappingURL=exceptions.js.map